module.exports = __webpack_public_path__ + "static/media/apprentice.77555ebf.svg";